import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ListsService } from 'src/core/lists/lists.service';
import { environment } from 'src/environments/environment';

import {ConfigService} from '../../../../../core/service/config.service';

@Component({
  selector: 'app-sub-category-page',
  templateUrl: './sub-category-page.component.html',
  styleUrls: ['./sub-category-page.component.css']
})
export class SubCategoryPageComponent implements OnInit {
  subCategoryName: any;
  category:any = {};
  public sidenavOpen = true;
  imagePath: any;
  constructor(
    public route: ActivatedRoute,
    private listsService: ListsService,
    private configService: ConfigService,
  ) { }

  ngOnInit(): void {
    this.imagePath = this.configService.getImageUrl();
    this.route.params.subscribe(params => {
      this.subCategoryName = params['id'];
      this.subCategoryFilter()
      console.log(this.subCategoryName); // This will log 'Air-Conditioners'
      // Use this.subCategoryName wherever you need it in your component
    });
  }
  subCategoryFilter() {
   
      const params = {
        categorySlug: this.subCategoryName,
        settingsId: environment.settingsId
      };
      this.listsService.getSubCategoryList(params)
        .subscribe((res: any) => {
this.category = res.categoryDataId

console.log("&&&&&",this.category)

          console.log('-res1',this.category)
      //     this.subCategory = res?.categoryDataId?.children1.sort((a, b) => {
      //   const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive comparison
      //   const nameB = b.name.toUpperCase();
        
      //   if (nameA < nameB) {
      //     return -1; // If nameA should appear before nameB
      //   }
      //   if (nameA > nameB) {
      //     return 1; // If nameA should appear after nameB
      //   }
      //   return 0; // If nameA and nameB are equivalent
      // });
      // console.log('res 2',this.subCategory)
        });

      //  this.subCategory =  this.rawSubCategory
        
    
  }

  receiveProgress(event) {
    console.log(event)

  }
}
